import React, { useState } from 'react'

import { Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import TableManage from './TableManage'

import ManageMasterDataForm from './ManageMasterDataForm'
import { addMasterDataBy, getMasterDataSchema } from '../../../redux/actions/manageMasterData'
import notification from '../../../utils/notification'
import { SAVE_FAILED_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'

export default function ManageMasterDataWidget(props) {
  const { title, table } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [loading, setloading] = useState(false)
  const [clearValue, setClearValue] = useState(false)

  const onSubmit = (data) => {
    let request = {
      tableName: table,
      id: data.id || null,
      name: data.name || '',
      sequence: data.sequence || 0,
    }
    handleAddMasterDataBy(request)
  }

  const handleAddMasterDataBy = async (request) => {
    startLoading()
    setloading(true)
    try {
      const response = await addMasterDataBy(request)

      if (response.model) {
        handleGetSchema()
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: SAVE_FAILED_MSG,
        duration: 5000,
      })
    }
    setloading(false)
    doneLoading()
  }

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getMasterDataSchema(table)
      // console.log('schema ', _schema.model.forms)
      setFormSchema(_schema.model.forms)
      setValueNullField()
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSingleSubmitMain = (obj) => {
    // console.log('id', obj.ig)
    sessionStorage.setItem('projectId', obj.id)
    sessionStorage.setItem('param', '')

    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }

  const setValueNullField = () => {
    setClearValue(true)
    setTimeout(() => {
      setClearValue(false)
    }, 500)

    clearErrors()
  }

  // console.log('ggggoooo => ', formSchema.inputForm.isSequence)

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded header={`เพิ่ม${title}`} collapsible defaultExpanded>
        {formSchema.inputForm && (
          <>
            <ManageMasterDataForm
              schema={formSchema.inputForm}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              clearValue={clearValue}
            />
            <hr />

            <ButtonPanelWidget
              isEdit={true}
              isError={isError}
              buttonText={formSchema?.manageForm?.buttonText || { saveButtonName: 'บันทึก' }}
              onSave={handleSubmit(onSubmit)}
            />
          </>
        )}
      </Panel>

      <TableManage
        schema={formSchema.tableList}
        isShowSequence={formSchema.inputForm.isSequence}
        title={title}
        table={table}
        single={{
          enable: true,
        }}
        onSingleSubmit={onSingleSubmitMain}
        pagination={true}
        rowCanEdit={true}
      />
    </>
  )
}
